import React from 'react'
import { IconButton } from '@material-ui/core'
import { ReactComponent as DeleteIcon } from 'assets/img/delete-icon-redesign.svg'
import { StyledIconButton } from './RemoveFilterButton.styles'

const RemoveFilterButton = ({ removeFn }: { removeFn: () => void }) => (
  <StyledIconButton>
    <IconButton onClick={removeFn} aria-label="remove filter">
      <DeleteIcon />
    </IconButton>
  </StyledIconButton>
)

export default RemoveFilterButton
